import React from "react";
import EmployerPage from "../../componentLayer/pages/Employer/EmployerPage.jsx";

export const employerRouter = [
  {
    index: true,
    element: <EmployerPage />,
  },
];
